module.exports = __webpack_public_path__ + "img/2.e0739e95.png";